import { createSelector } from 'reselect'
import createCachedSelector from 're-reselect'
import {
  _processQueryStringPart,
  _splitQueryString,
  constructSearchQueryObject,
} from 'util/search'
import { filterRegex } from 'util/search/filter'
import { emptyArr } from 'util/arrays'
import { selectKnownMailboxes } from 'selectors/mailboxes/selectKnownMailboxes'
import { selectMailboxesById } from 'selectors/mailboxes/selectMailboxesById'
import { getMailboxNameOrEmail } from 'util/mailboxes'
import { selectTicketSearchOperatorValueMap } from './base'

export const selectTicketSearchQueryObjectByQueryString = createCachedSelector(
  (_state, queryString) => queryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)((_state, queryString) => queryString || 'unknown')

export function selectCurrentSubmittedTicketSearchQueryString(state) {
  const { submittedSearchQueryString } = state.search
  if (submittedSearchQueryString || submittedSearchQueryString === '') {
    return submittedSearchQueryString
  }
  return null
}

export const selectCurrentSubmittedTicketSearchQueryObject = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)

export const selectCurrentSubmittedTicketSearchFilterMatches = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  submittedSearchQueryString => {
    if (!submittedSearchQueryString) return []
    return (
      Array.from(
        new Set(submittedSearchQueryString.match(new RegExp(filterRegex, 'g')))
      ) || []
    )
  }
)

export const selectSearchMailboxIds = state =>
  state.search.searchMailboxIds || emptyArr
export const selectIsReloadingSubmittedSearchQuery = state =>
  state.search.isReloadingSubmittedSearchQuery

export const selectSearchEditorState = state => state.search.editorState
export const selectSearchEditor = state => state.search.editor

export const selectHumanizedSearchQueryArray = createCachedSelector(
  selectKnownMailboxes,
  selectMailboxesById,
  (_state, queryString) => queryString,
  (mailboxes, mailboxesById, queryString) => {
    const parts = _splitQueryString(queryString)
    const results = parts
      .map(part => {
        if (!part) return part
        const filter = _processQueryStringPart(part)
        const filterName = `${filter.key}:`
        const value = filter.values[0]
        if (filterName === 'inbox:') {
          const mailbox = mailboxesById[value]
          if (!mailbox) return part
          return [filter.key, getMailboxNameOrEmail(mailbox, mailboxes)].join(
            ':'
          )
        }
        return part
      })
      .filter(Boolean)
    return Array.from(new Set(results))
  }
)((_state, queryString) => queryString || 'unknown')
